import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import { CircularProgress } from '@material-ui/core';
import axios from 'axios';

export default function ProductListPdfDownloadButton({
	pedido,
	children = 'Descargar PDF',
	...buttonAttrs
}) {
	const [loading, setLoading] = useState(false);

	const formatPrice = (price) => {
		if (typeof price === 'number') {
			return `${price.toFixed(2)}€`;
		}
		return price ? `${price}€` : '0.00€';
	};

	const handleDownloadPDF = async () => {
		if (!pedido || !pedido.DETAILS || pedido.DETAILS.length === 0) {
			alert('No hay productos para descargar');
			return;
		}

		try {
			setLoading(true);

			const timestamp = Date.now();
			const currentDate = new Date().toLocaleDateString('es-ES', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
			});

			const headers = ['ID', 'Producto', 'Cantidad', 'Precio Unit.', 'Total'];
			const products = pedido.DETAILS.map((detail) => [
				detail.PRODUCT_ID?.toString() || '',
				detail.DESCRIPTION || '',
				detail.AMOUNT?.toString() || '0',
				formatPrice(detail.UNIT_PRICE),
				formatPrice(detail.TOTAL_PRICE),
			]);

			const requestData = {
				templateName: 'list',
				data: {
					title: `Productos del Pedido ${pedido.ID || ''}`,
					subtitle: `Generado el ${currentDate}`,
					headers: headers,
					data: products,
				},
				fileName: `productos_${timestamp}.pdf`,
			};

			const response = await axios.post('/api/pdf/generate', requestData, {
				responseType: 'blob',
				withCredentials: true,
			});

			if (!response.success) {
				throw new Error('Error al generar el PDF');
			}

			const blob = new Blob([response.data], { type: 'application/pdf' });
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.target = '_blank';
			a.rel = 'noopener noreferrer';
			a.style.display = 'none';
			// a.download = `productos_${timestamp}.pdf`;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Error al generar PDF:', error.message);
			if (error.code === 'ECONNABORTED') {
				alert(
					'Tiempo de espera agotado. El PDF no se pudo generar. Intenta de nuevo.'
				);
			} else {
				alert(
					'No se pudo generar el PDF. Por favor, intenta de nuevo más tarde.'
				);
			}
		} finally {
			setLoading(false);
		}
	};

	const isDisabled =
		!pedido || !pedido.DETAILS || pedido.DETAILS.length === 0 || loading;

	buttonAttrs = {
		color: 'primary',
		variant: 'contained',
		startIcon: loading ? <CircularProgress size={'1rem'} /> : <GetAppIcon />,
		...buttonAttrs,
	};

	return (
		<Button {...buttonAttrs} onClick={handleDownloadPDF} disabled={isDisabled}>
			{loading ? 'Generando PDF...' : children}
		</Button>
	);
}
